<template>
  <div class="component">
    <div class="component-title">其他服务费</div>
    <!-- <table style="margin-bottom: 24px;">
      <tbody>
        <tr style="height: 64px;">
          <td width="23%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">回单</td>
          <td width="77%" style="font-size: 12px;color: #EC892E;">免费</td>
        </tr>
        <tr style="height: 64px;">
          <td width="23%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">返程</td>
          <td width="77%" style="font-size: 12px;">附加40%里程费</td>
        </tr>
      </tbody>
    </table> -->
    <div class="main-points">
      <div class="title">基础装卸搬运费</div>
      <div class="min-title">小件物品的装卸和短距离平地搬运</div>
      <div class="content">半车/整车:不足一半货厢/超过一半货厢<br />小件物品：单件重量低于20kg且小于1m3的货物短距离平地运输:搬运距离低于50米</div>
    </div>
    <div class="main-points">
      <div class="title">楼层费</div>
      <div class="min-title">小件物品的上楼或下楼搬运，楼层搬运不可因趟数加收费</div>
      <div class="content">1.不用上楼时，不收楼层费<br /> 2.需要上楼且有电梯时，加收1层楼层费<br />3.需要上楼且没有电梯时，按搬运楼层数额外收费，超出9楼时建议商议价格</div>
    </div>
    <div class="main-points">
      <div class="title">大件搬运费</div>
      <div class="min-title">大件物品的上货或下货、短距离平地搬运和上楼或下楼搬运</div>
      <div class="content">大件物品:单件重量在20公斤到45公斤间，且不是因超大/超长/异形导致难以搬运的物品。<br />例如：小型冰箱，小型洗衣机，悬挂式空调，单门衣柜，普通家用电视，1米以下鱼缸，其他大件</div>
    </div>
    <div class="main-points">
      <div class="title">卡板/箱子搬运费</div>
      <div class="min-title">卡板/箱子的上货或下货、短距离平地拖车搬运和货梯拖车上楼或下楼搬运</div>
      <div class="content">卡板:只针对0.5*0.8m、1.0*1.1m、1.1*1.3m等常规卡板，因超大/超长/异形导致难以搬运的卡板不计算在内。<br />箱子：只针对卡板装载未满的尾板箱子，其他情况不计算在内</div>
      <div style="font-size: 12px;line-height: 20px;color: #FFBD2D;">（可根据散货标准按散货计算）</div>
    </div>
    <div class="main-points">
      <div class="title">其他搬运服务费</div>
      <div class="min-title">司机额外提供的其他搬运服务</div>
      <div class="content">如叫其他搬运工、超重/超长/超大/异形等超限物品、远距离平地运输、货物拆装服务等<br />对于有明确行业标准的物品的搬运，搬运费优先以行业标准进行计算;<br />如有其他未提及的特殊物品，搬运费以司机和货主协商确认的价格为准。</div>
    </div>
  </div>
</template>

<script>
export default {
  name:"OtherFee"
}
</script>

<style scoped lang="scss">
  .main-points + .main-points {
    margin-top: 20px;
  }
  .main-points {
    .title {
      font-size: 16px;
      font-weight: bold;
      line-height: 32px;
    }
    .min-title {
      font-size: 13px;
      font-weight: bold;
      line-height: 29px;
      margin-bottom: 6px;
    }
    .content {
      font-size: 12px;
      line-height: 20px;
      color: #817A74;
    }
  }
  table,
  th,
  td {
    border: 1px solid #C9C2BB;
  }

  table {
    width: 100%;
    margin: 0 auto;
    display: table;
    border-spacing: 0;
    border-radius: 4px;
    overflow: hidden;
  }
  th,
  td {
    border-top-width: 0;
    border-left-width: 0;
    text-align: center;
  }

  th:last-child,
  td:last-child {
    border-right-width: 0;
  }

  tr:last-child td {
    border-bottom-width: 0;
  }

  td tr td{
    border-top: 1px solid #C9C2BB;
  }
  td tr:first-child td {
    border-top: 0;
    border-bottom: 0;
  }
  table tbody > tr > td:first-child {
    background-color: #F8F8F8;
  }
</style>